import { useState } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "@/components/Toast";

// Con responseType "blob" el error del backend llega como Blob: se lee para mostrar el motivo real.
async function blobError(e) {
  const d = e?.response?.data;
  if (d instanceof Blob) {
    try {
      const j = JSON.parse(await d.text());
      if (j?.detail) return typeof j.detail === "string" ? j.detail : JSON.stringify(j.detail);
    } catch { /* no era JSON */ }
  }
  return formatApiError(e);
}

function saveBlob(res, fallback) {
  const m = /filename="([^"]+)"/.exec(res.headers?.["content-disposition"] || "");
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a"); a.href = url; a.download = m ? m[1] : fallback;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

/** Fix BS (2026-11-03): exporta a CSV o PDF exactamente las filas que se ven con los filtros actuales
 * (POST /api/exports/{kind} con sus ids). `filtersLabel` se imprime en el PDF. */
export function ExportButtons({ kind, rows, filtersLabel, testIdPrefix }) {
  const [busy, setBusy] = useState(null);
  const prefix = testIdPrefix || kind;
  const run = async (format) => {
    const ids = (rows || []).map((r) => r.id).filter(Boolean);
    if (!ids.length) { toast.error("No hay filas para exportar con estos filtros"); return; }
    setBusy(format);
    try {
      const res = await api.post(`/exports/${kind}`, { ids, format, filters_label: filtersLabel || null }, { responseType: "blob", timeout: 180000 });
      saveBlob(res, `${kind}.${format}`);
    } catch (e) { toast.error(await blobError(e)); }
    finally { setBusy(null); }
  };
  const btn = { padding: "8px 12px", fontSize: 11, display: "inline-flex", alignItems: "center", gap: 6 };
  return (
    <div style={{ display: "inline-flex", gap: 6 }} data-testid={`${prefix}-export`}>
      {["csv", "pdf"].map((f) => (
        <button key={f} type="button" className="btn-ghost" onClick={() => run(f)} disabled={!!busy} style={btn} data-testid={`${prefix}-export-${f}`}>
          {busy === f ? <Loader2 size={13} className="spin" /> : <FileDown size={13} />} {f.toUpperCase()}
        </button>
      ))}
    </div>
  );
}

/** Fix BS: una novedad en PDF (con fotos, seguimiento e historial). */
export async function downloadNewsPdf(id) {
  try {
    const res = await api.get(`/exports/news/${id}/pdf`, { responseType: "blob", timeout: 120000 });
    saveBlob(res, `novedad_${id.slice(0, 8)}.pdf`);
  } catch (e) { toast.error(await blobError(e)); }
}
